export default Object.freeze({
    DANKORT_BINS: [
        5019,
    ],
    LOPI_BINS: [
    ],
});
